var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-monospace text"},[_vm._v("Taka strona nie istnieje")])}
var staticRenderFns = []

export { render, staticRenderFns }